import ISitemapUrl from '@/interfaces/IUrl';
import Provider from '@/enums/Provider';
import { extractSitemapSections } from './extractSections';
import { normalizeFullUrlToConsistentFormat } from '@/utils/urlUtils';
import { buildSitemapUrl } from './buildSitemapUrl';

/**
 * Parses raw sitemap XML into an array of ISitemapUrl.
 */
export function parseSitemapUrls(
    sitemapContent: string,
    provider: Provider
): ISitemapUrl[] {
    const seen = new Set<string>();
    const results: ISitemapUrl[] = [];

    const sections = extractSitemapSections(sitemapContent);
    const parser = new DOMParser();

    sections.forEach(section => {
        const xml = section.replace(/<\?xml[^>]*?>/gi, '').trim();
        const doc = parser.parseFromString(xml, 'application/xml');
        if (doc.getElementsByTagName('parsererror').length) return;

        Array.from(doc.getElementsByTagName('url')).forEach(elem => {
            const loc = elem.getElementsByTagName('loc')[0]?.textContent || '';
            const key = normalizeFullUrlToConsistentFormat(loc);
            if (seen.has(key)) return;
            seen.add(key);

            // build URL object
            const obj = buildSitemapUrl(loc, provider);

            // extract optional fields
            obj.lastmod = elem.getElementsByTagName('lastmod')[0]?.textContent || '';
            obj.changefreq = elem.getElementsByTagName('changefreq')[0]?.textContent || '';
            obj.priority = elem.getElementsByTagName('priority')[0]?.textContent || '';

            results.push(obj);
        });
    });

    return results;
}